import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";
import {
  AppShell,
  CardPanel,
  FormField,
  PageHeader,
  PrimaryButton,
} from "../components";
import { clearClientSession } from "../config/auth";

const QuestionPage = () => {
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("Beloved");

  useEffect(() => {
    const id = localStorage.getItem("student_id");
    const name = localStorage.getItem("student_name");

    if (!id) {
      alert("⚠️ Student ID missing. Please scan the QR again.");
      navigate("/StudentPage");
      return;
    }

    setStudentId(id);

    if (name && name.trim()) {
      const firstName = name.trim().split(" ")[0];
      setStudentName(firstName || "Beloved");
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!question.trim()) {
      alert("❌ Question cannot be empty.");
      return;
    }

    try {
      const response = await fetch(apiUrl("/api/questions/ask"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id: studentId, question }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("✅ Question submitted:", data);
        navigate("/SubmissionPage");
      } else {
        alert(`❌ Submission failed: ${data.error || "Unknown error"}`);
      }
    } catch (err) {
      console.error("❌ Network error submitting question:", err);
      alert("Network error occurred. Please try again.");
    }
  };

  const handleLogout = () => {
    clearClientSession();
    navigate("/");
  };

  return (
    <AppShell logoPosition="bottom">
      <CardPanel className="ui-card-panel--center">
        <div className="ui-question-card">
          <div className="ui-question-card__head">
            <h2>
              Hi <strong>{studentName}</strong>,
            </h2>
            <p>Please enter your question or comment below.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <FormField
              label="Message"
              id="question"
              name="question"
              as="textarea"
              rows={7}
              value={question}
              onChange={(event) => setQuestion(event.target.value)}
              placeholder="Type in your questions or leave a comment"
              required
            />

            <PrimaryButton type="submit" className="ui-auth-submit" size="lg">
              SUBMIT
            </PrimaryButton>
          </form>
        </div>
      </CardPanel>
    </AppShell>
  );
};

export default QuestionPage;
